import { ButtonInterface } from 'common/types/entities/button-interface'
import React from 'react'
import { CommonButtonSettings } from '../common-button-settings'

interface LoginButtonSettingsProps {
  entity: ButtonInterface
  defaultEntity?: ButtonInterface
}

export const LoginButtonSettings = ({
  entity,
  defaultEntity,
}: LoginButtonSettingsProps) => {
  return <CommonButtonSettings entity={entity} defaultEntity={defaultEntity} />
}
